export default __webpack_public_path__ + "static/media/image-upload-text-gray.d7ff485f.svg";